import LZString from 'lz-string';

/**
 * Stores a value in localStorage after compressing it with LZString.
 */
export const setCompressedItem = <T>(key: string, value: T): void => {
  const compressed = LZString.compress(JSON.stringify(value));
  localStorage.setItem(key, compressed);
};

/**
 * Retrieves and decompresses a value from localStorage.
 * Returns null if the key doesn't exist or decompression fails.
 */
export const getCompressedItem = <T>(key: string): T | null => {
  const compressed = localStorage.getItem(key);
  if (!compressed) return null;
  try {
    const decompressed = LZString.decompress(compressed);
    return decompressed ? JSON.parse(decompressed) : null;
  } catch {
    return null;
  }
};
